import { render, staticRenderFns } from "./DateColumn.vue?vue&type=template&id=35f2eab7&scoped=true&"
import script from "./DateColumn.vue?vue&type=script&lang=js&"
export * from "./DateColumn.vue?vue&type=script&lang=js&"
import style0 from "./DateColumn.vue?vue&type=style&index=0&id=35f2eab7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f2eab7",
  null
  
)

export default component.exports